// @flow
export { default } from './OrderRefundTemplate';



// WEBPACK FOOTER //
// ./src/components/order/OrderRefundTemplate/index.js